import React from "react";
import {
  TextInput,
  Edit,
  SimpleForm,
  DateInput,
  ReferenceInput,
  BooleanInput,
  SelectInput,
} from "react-admin";

export const EnrollEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <ReferenceInput source="userId" reference="users">
        <SelectInput optionText="username" />
      </ReferenceInput>
      <ReferenceInput source="klassId" reference="klasses">
        <SelectInput optionText="title" />
      </ReferenceInput>
      <ReferenceInput source="paymentId" reference="payments">
        <SelectInput optionText="id" />
      </ReferenceInput>
      <DateInput source="study_period" />
      <BooleanInput source="is_valid" />
      <DateInput source="createdAt" />
    </SimpleForm>
  </Edit>
);
